import { UserIdentity } from "~/api/Api";

export const formatIdentityName = (
  identity: UserIdentity,
  variant: "full" | "short",
) => {
  if (!identity.profile) {
    return `Account #${identity.id}`;
  }

  const fullName = [identity.profile.first_name, identity.profile.last_name]
    .filter(Boolean)
    .join(" ");

  if (fullName && variant === "full") {
    return `${fullName} (${identity.profile.email})`;
  }

  if (fullName && variant === "short") {
    return fullName;
  }

  return identity.profile.email;
};
